import { render, staticRenderFns } from "./CopyrightBar.vue?vue&type=template&id=526bf1c4&scoped=true"
import script from "./CopyrightBar.vue?vue&type=script&lang=js"
export * from "./CopyrightBar.vue?vue&type=script&lang=js"
import style0 from "./CopyrightBar.vue?vue&type=style&index=0&id=526bf1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bf1c4",
  null
  
)

export default component.exports